// Full Menu List Componenet
export default class MenuList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="cardMenu-border">
                <a href={this.props.cardUrl} data-href={this.props.cardUrl} data-type="add-to-bag" className={"listing-card-item " + (this.props.menuCategoryUnavailable ? 'js-not-available' : '')}>
                    <div className="cardMenu-box">
                        <div className="row item-center">
                            <div className="cardMenu-image">
                                <div className="img-section">
                                    <img src={this.props.menuCategoriesImage} className="ml-auto imgCard" alt={this.props.menuCategoriesTitle} />
                                </div>
                            </div>
                            <div className="cardMenu-descirption">
                                <div className="h_6 cardMenu-heading text-truncate">{this.props.menuCategoriesTitle}</div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        );
    }
}
